import React from "react";
import { connect } from "react-redux";
import { getArticle, editArticle } from "../../actions/articles";
import {
  Container,
  Card,
  CardHeader,
  CardBody,
  Button,
  FormGroup,
  UncontrolledAlert,
  Modal,
} from "reactstrap";
import ReactCrop from "react-image-crop";
import TextEditor from "../../components/Commons/TextEditor";
import ArticleForm from "../../components/articles/ArticleForm";
import OverlayLoading from "../../components/Commons/OverlayLoading.jsx";
import moment from "moment";
import { DOMAIN } from "../../utils/constant";
import { Link } from "react-router-dom";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import twitter from "../../assets/img/icons/common/twitter.svg";
import wechat from "../../assets/img/icons/common/wechat.svg";
import weibo from "../../assets/img/icons/common/weibo.svg";
import facebook from "../../assets/img/icons/common/facebook.svg";
import IconUser from "../../components/Icon/User.jsx";

class AricleEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      article: {},
      crop: {
        unit: "%",
        width: 30,
        aspect: 16 / 10,
      },
      src: null,
      croppedImageUrl: null,
      editable: false,
      previewModal: false,
    };
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onContentChange = this.onContentChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.onImageLoaded = this.onImageLoaded.bind(this);
    this.onCropComplete = this.onCropComplete.bind(this);
    this.onCropChange = this.onCropChange.bind(this);
    this.onSelectFile = this.onSelectFile.bind(this);

    this.makeClientCrop = this.makeClientCrop.bind(this);
    this.getCroppedImg = this.getCroppedImg.bind(this);
    this.confirmImg = this.confirmImg.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.id = id;
    this.props.getArticle(id);
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.articles.selectedArticle !== this.props.articles.selectedArticle
    ) {
      let article = newProps.articles.selectedArticle;
      if (article.categories) {
        article.category_ids = [];
        for (let i = 0; i < article.categories.length; i++) {
          article.category_ids.push(article.categories[i].id);
        }
      }
      if (article.cover_image) {
        this.setState({ croppedImageUrl: DOMAIN + article.cover_image });
      }

      this.setState({
        article: article,
      });
    }
  }

  toggleModal = (state) => {
    this.setState({
      previewModal: !this.state.previewModal,
    });
  };

  onTextInputChange(e, target) {
    let value = e.target.value;
    let article = this.state.article;
    article[target] = value;
    this.setState({
      article: article,
    });
  }

  onContentChange(model) {
    let value = model;
    let article = this.state.article;
    article["body"] = value;
    this.setState({
      article: article,
    });
  }

  handleCheckBoxChange(e) {
    const { checked, value } = e.target;
    let article = this.state.article;
    if (checked && article.category_ids.indexOf(value) === -1) {
      article.category_ids.push(parseInt(value));
    } else {
      article.category_ids = article.category_ids.filter(
        (id) => id !== parseInt(value)
      );
    }
    this.setState({
      article: article,
    });
  }

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
    this.setState({
      editable: true,
    });
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    //图片缩放
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    /**
    
     * 画布大小
     */
    // 图片原始尺寸
    var originWidth = crop.width * scaleX;
    var originHeight = crop.height * scaleY;
    // 最大尺寸限制
    var maxWidth = 1200,
      maxHeight = 1200 / (16 / 9);
    // 目标尺寸
    var targetWidth = originWidth,
      targetHeight = originHeight;
    // 图片尺寸超过1200x1200的限制
    if (originWidth > maxWidth || originHeight > maxHeight) {
      if (originWidth / originHeight > maxWidth / maxHeight) {
        // 更宽，按照宽度限定尺寸
        targetWidth = maxWidth;
        targetHeight = Math.round(maxWidth * (originHeight / originWidth));
      } else {
        targetHeight = maxHeight;
        targetWidth = Math.round(maxHeight * (originWidth / originHeight));
      }
    }
    // canvas对图片进行缩放
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image, //原始图片
      crop.x * scaleX, //x-axis coordinate of  top left corner of source image
      crop.y * scaleY, //y-axis coordinate of top left corner of source image
      crop.width * scaleX, //the width of the sub-rectangle of the source image
      crop.height * scaleY, //the height of the sub-rectangle of the source image
      0, //x-axis coordinate in the destination canvas at which to place the top-left corner of the source image.
      0, //y-axis coordinate in the destination canvas at which to place the top-left corner of the source image.
      targetWidth, //The width to draw the image in the destination canvas. This allows scaling of the drawn image.
      targetHeight //The height to draw the image in the destination canvas. This allows scaling of the drawn image.
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            console.error("Canvas is empty");
            return;
          }
          blob.name = fileName;
          this.setState({
            file: blob,
          });
          window.URL.revokeObjectURL(this.fileUrl);
          this.fileUrl = window.URL.createObjectURL(blob);
          resolve(this.fileUrl);
        },
        "image/png",
        1
      );
    });
  }

  confirmImg() {
    this.setState({
      editable: false,
    });
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  submitArticle() {
    let { file, article } = this.state;
    const post_id = article.id;
    const category_ids = article.category_ids;
    const title = article.title;
    const body = article.body;
    const status = article.status;
    const cover_img = file;
    const author_name = article.author;
    const published_at = article.published_at;
    const tick_expires_at = article.tick_expires_at;
    this.props.editArticle({
      post_id,
      category_ids,
      title,
      body,
      status,
      cover_img,
      author_name,
      published_at,
      tick_expires_at,
    });
  }

  render() {
    const { crop, croppedImageUrl, src, editable } = this.state;
    let { getArticleRequest, errorMsg, errors, editArticleRequest } =
      this.props.articles;
    const coverImg = this.state.croppedImageUrl
      ? this.state.croppedImageUrl
      : DOMAIN + "resources/cloud-upload-light.png";
    var sectionStyle = {
      width: "100%",
      paddingBottom: "60%",
      height: "0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      background:
        'url("' +
        coverImg +
        '") center center / cover no-repeat rgb(255, 255, 255)',
    };
    var fileInputStyle = {
      position: "absolute",
      opacity: 0,
      right: 0,
      top: 0,
      bottom: 0,
      left: 0,
      filter: "alpha(opacity = 0)",
      cursor: "pointer",
    };
    var uploadBtnWrapper = {
      position: "relative",
      display: "block",
      borderRadius: "6px",
      cursor: "pointer",
    };

    return (
      <Container className="mt-4" fluid>
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between">
              <div>編輯文章</div>
              <div className="d-flex align-items-center">
                <Button
                  color="secondary"
                  tag={Link}
                  to={"/dash/admin/articles"}
                >
                  返回
                </Button>
              </div>
            </div>
          </CardHeader>
          <OverlayLoading loading={getArticleRequest}>
            <CardBody className="row">
              <div className="col-lg-8 px-4">
                <TextEditor
                  content={this.state.article ? this.state.article.body : ""}
                  onContentChange={this.onContentChange}
                  postId={this.props.match.params.id}
                />
              </div>
              <div className="col-lg-4 px-4">
                {errorMsg && (
                  <UncontrolledAlert color="danger" fade={false}>
                    <span className="alert-inner--text">{errorMsg}</span>
                  </UncontrolledAlert>
                )}
                <ArticleForm
                  data={this.state.article}
                  onTextInputChange={this.onTextInputChange}
                  handleCheckBoxChange={this.handleCheckBoxChange}
                  submitArticle={this.submitArticle}
                  loading={editArticleRequest}
                  togglePreview={this.toggleModal}
                />

                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="example-date-input"
                  >
                    封面圖片
                  </label>
                  {src && editable && (
                    <ReactCrop
                      src={src}
                      crop={crop}
                      onImageLoaded={this.onImageLoaded}
                      onComplete={this.onCropComplete}
                      onChange={this.onCropChange}
                    />
                  )}
                  {!editable && <div style={sectionStyle}></div>}
                  <div className="d-flex flex-row">
                    {editable && (
                      <button
                        type="button"
                        className="mt-2 btn btn-default"
                        onClick={this.confirmImg}
                      >
                        確認
                      </button>
                    )}
                    <div className="mt-2" style={uploadBtnWrapper}>
                      <button
                        type="button"
                        style={{ cursor: "pointer" }}
                        block={true}
                        className="btn btn-default"
                      >
                        上傳圖片
                      </button>
                      <input
                        style={fileInputStyle}
                        type="file"
                        onChange={this.onSelectFile}
                        accept="image/x-png,image/gif,image/jpeg"
                      />
                    </div>
                  </div>
                </FormGroup>

                <p>
                  上次更新：{this.formatTime(this.state.article.updated_at)}
                </p>
                <p>瀏覽次數：{this.state.article.views}</p>
                <p>
                  編輯：
                  {this.state.article.editor
                    ? this.state.article.editor.name
                    : "N/A"}
                </p>
              </div>
            </CardBody>
          </OverlayLoading>
        </Card>
        <Modal
          className="modal-dialog-centered modal-lg"
          isOpen={this.state.previewModal}
          toggle={() => this.toggleModal()}
        >
          <div className="modal-header">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal()}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <h1>{this.state.article ? this.state.article.title : ""}</h1>
            <p className="d-flex align-items-center">
              {this.state.article
                ? moment(this.state.article.published_at).format("YYYY-MM-DD")
                : ""}
              &nbsp;&nbsp;&nbsp;&nbsp; <IconUser className="size-4" />
              &nbsp;
              {this.state.article ? this.state.article.author : ""}{" "}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <img src={weibo} alt="weibo" />
              &nbsp;
              <img src={wechat} alt="wechat" />
              &nbsp;
              <img src={twitter} alt="twitter" />
              &nbsp;
              <img src={facebook} alt="facebook" />
            </p>
            <hr className="my-3" />
            {!editable && <div className="my-4" style={sectionStyle}></div>}
            <FroalaEditorView
              model={this.state.article ? this.state.article.body : ""}
            />
            <p>
              分享至 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <img src={weibo} alt="weibo" />
              &nbsp;
              <img src={wechat} alt="wechat" />
              &nbsp;
              <img src={twitter} alt="twitter" />
              &nbsp;
              <img src={facebook} alt="facebook" />
            </p>
          </div>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    articles: state.articles,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getArticle: (params) => dispatch(getArticle(params)),
    editArticle: (params) => dispatch(editArticle(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AricleEditPage);
